import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { useEffect } from 'react';
import {
  MemoryRouter,
  Outlet,
  Route,
  Routes,
  useNavigate,
} from 'react-router-dom';
import { TabRoutes } from '../constants/routes';
import DemoPlayScreen from '../screens/DemoPlayScreen';

const NavigationHandler = ({ tab }: { tab: IGlobalTab }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (tab.routeTo) navigate(tab.routeTo);
  }, []);
  return null;
};

export const GroupRouter = ({ tab }: { tab: IGlobalTab }) => {
  return (
    <MemoryRouter>
      <Routes>
        <Route
          path="/*"
          element={
            <>
              <NavigationHandler tab={tab} />
              <Outlet />
            </>
          }
        >
          <Route
            path={TabRoutes.PLAYBOOK_PRESENTATION_DEMO_PRESENT}
            element={
              <DemoPlayScreen
                tab={tab}
                withRouter={false}
              />
            }
          />
        </Route>
      </Routes>
    </MemoryRouter>
  );
};
